import { __read } from "tslib";
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { noop } from '@slardar/sdk-template';
import { getDefaultPerformanceObserver, applyPerformanceObserver } from '../../../utils';
import { initMetric } from '../util';
var CLSMonitorMetricName = 'cls';
var LS = 'layout-shift';
export var CLSMonitor = function (PerformanceObserver) {
    if (PerformanceObserver === void 0) { PerformanceObserver = getDefaultPerformanceObserver(); }
    return function (props, cb) {
        var _a = __read(props, 1), precollect = _a[0];
        var metric = initMetric(CLSMonitorMetricName, 0);
        if (!PerformanceObserver) {
            metric.isSupport = false;
            return [function () { return cb && cb(metric); }, noop];
        }
        var cumulativeCLS = function (_a) {
            var hadRecentInput = _a.hadRecentInput, value = _a.value;
            if (!hadRecentInput) {
                metric.value += value;
            }
        };
        (precollect.entries || []).forEach(function (entry) {
            entry.entryType === LS && cumulativeCLS(entry);
        });
        var _b = __read(applyPerformanceObserver(PerformanceObserver, cumulativeCLS), 2), observe = _b[0], disconnect = _b[1];
        observe(LS);
        return [
            function () {
                cb && cb(metric);
                metric = initMetric(CLSMonitorMetricName, 0);
            },
            disconnect,
        ];
    };
};
//# sourceMappingURL=index.js.map